import httpService from "../../services/httpService";

export interface SendSingleNotificationPayload {
  title: string;
  body: string;
  data?: Record<string, any>;
  userId?: string;
  token?: string;
  dryRun?: boolean;
}

export async function sendSingleNotification(payload: SendSingleNotificationPayload) {
  try {
    const response = await httpService.postRaw("/notifications/send-single", payload);
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 429) {
      throw new Error("Çok sık istek atıldı. Lütfen daha sonra tekrar deneyin.");
    }
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
}
